import { componentThemes } from './componentThemes';
import { tokens } from './tokens';

// Main theme configuration
export const theme = {
  // Core design tokens
  tokens,

  // Component themes
  components: componentThemes,

  // Legacy compatibility - for gradual migration
  colors: tokens.colors,
  typography: tokens.typography,
  spacing: tokens.spacing,
  borderRadius: tokens.borderRadius,
  borderWidth: tokens.borderWidth,
  shadows: tokens.shadows,
  zIndex: tokens.zIndex,
} as const;

// Export individual parts for easier imports
export { tokens, componentThemes };

// Legacy font exports for backward compatibility
export const regularFont = tokens.typography.fontFamilies.regular;
export const boldFont = tokens.typography.fontFamilies.bold;

// Type definitions
export type Theme = typeof theme;
export type ThemeColors = typeof theme.colors;
export type ThemeTypography = typeof theme.typography;
export type ThemeSpacing = typeof theme.spacing;
export type ThemeBorderRadius = typeof theme.borderRadius;
export type ThemeBorderWidth = typeof theme.borderWidth;
export type ThemeShadows = typeof theme.shadows;
export type ThemeZIndex = typeof theme.zIndex;
export type ThemeComponents = typeof theme.components;

// Default export
export default theme;
